/* src/app/reporting/pages/report-jobs-sepa/report-jobs-sepa.component.scss */
/*# sourceMappingURL=report-jobs-sepa.component.css.map */
